<script setup lang="ts">
    import { onMounted, ref } from 'vue';
    import { useRouter } from 'vue-router';
    import { getDocumentationTopicLink } from '@/shared/helpers/routing';
    import { Topic, getTopics } from './data';
    import Spinner from '@/shared/components/Spinner.vue';
    import DocumentationBrowserContainer from './DocumentationBrowserContainer.vue';

    const router = useRouter();

    const loading = ref<boolean>(false);
    const topics = ref<Topic[]>([]);

    onMounted(async () => {
        try {
            loading.value = true;
            topics.value = await getTopics();
        } finally {
            loading.value = false;
        }
    });

</script>

<template>
    <documentation-browser-container>
        <spinner :loading="loading">
            <h2 class="title is-5">
                Topics
            </h2>
            <div class="fixed-grid has-1-cols-mobile has-3-cols-tablet has-3-cols-desktop">
                <div class="grid is-gap-2">
                    <div
                        v-for="topic in topics"
                        class="topic clickable"
                        @click="router.push(getDocumentationTopicLink(topic.identity))">
                        <p class="topic-name">
                            {{ topic.name }}
                        </p>
                        <p class="topic-description">
                            {{ topic.description }}
                        </p>
                    </div>
                </div>
            </div>
        </spinner>
    </documentation-browser-container>
</template>

<style scoped>
.clickable:hover {
    cursor: pointer;
    opacity: 0.8;
}
.topic {
    border-style: solid;
    border-width: 2px;
    border-color: var(--eq-autumn-storm-1);
    background-color: var(--eq-autumn-storm-3);
    padding: 1em;
    border-radius: 10px;
}
.topic-name {
    font-weight: bold;
    font-size: 120%;
    color: var(--eq-norwegian-woods-1);
}
.topic-description {
    font-weight: normal;
    font-size: 110%;
    color: var(--eq-norwegian-woods-1);
}
</style>
